var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0563 3.19296e-05C20.3104 0.0160339 24.3762 1.45621 27.3503 3.98452C30.3432 6.52883 32.0185 9.96926 31.9997 13.5377V13.6177C31.8867 18.4663 28.6868 22.9309 24.6962 26.4193C22.4374 28.3875 19.9339 30.1317 17.2045 31.6039C16.4704 32.132 15.3975 32.132 14.6634 31.6039C10.6164 29.3636 7.03993 26.5473 4.14114 23.2669C1.59998 20.4185 0.150587 16.9941 0 13.4257C0.0376467 5.98477 7.22816 -0.01597 16.0563 3.19296e-05ZM16.0554 18.0173C17.3919 18.0173 18.6719 17.5853 19.613 16.8012C20.5918 15.9851 21.1396 14.8985 21.1396 13.7608C21.1396 11.3925 18.8601 9.48826 16.0554 9.48826C13.2507 9.48826 10.9919 11.3925 10.9919 13.7608C10.9919 16.0987 13.2131 17.9853 15.9989 18.0173H16.0554Z",
    fill: "#1D619D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.60d53b1a4471f2a775b0b95890522461.svg";
export { ForwardRef as ReactComponent };